import { useEffect } from "react";

// Add <meta name="robots" content="noindex,nofollow"> for the lifetime
// of the calling component, then remove it on unmount. Belt and braces
// alongside robots.txt Disallow for admin/auth routes; robots.txt is
// advisory, so this gives crawlers a second, page-level "do not index"
// signal via HTML.
export function useNoIndex() {
  useEffect(() => {
    let el = document.head.querySelector('meta[name="robots"]');
    let createdByUs = false;
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute("name", "robots");
      document.head.appendChild(el);
      createdByUs = true;
    }
    const prev = el.getAttribute("content");
    el.setAttribute("content", "noindex,nofollow");
    return () => {
      if (createdByUs) {
        document.head.removeChild(el);
      } else if (prev != null) {
        el.setAttribute("content", prev);
      }
    };
  }, []);
}
